export const INTERNAL_COL_DEFINE = 'CDS_TABLE_INTERNAL_COL_DEFINE';
export const INTERNAL_HOOKS = 'CDS_TABLE_INTERNAL_HOOK';
export const TABLE_INDENT_SIZE = 20;
